import { observer } from "mobx-react-lite";
import React from "react";
import { Col, Form } from "react-bootstrap";
import FormGroup from "controls/formGroup";
import FormLabel from "controls/formLabel";
import type InternalReportsCreateViewModel from "viewModels/timeCharges/reporting/internalReports/internalReportsCreateViewModel";
import type InternalReportsViewModel from "viewModels/timeCharges/reporting/internalReports/internalReportsViewModel";
import { Modal } from "react-bootstrap";
import AdvancedSelect from "@edaz/edazkit/controls/AdvancedSelect";
import Button from "@edaz/edazkit/Button";
import { IconType } from "@edaz/edazkit/Icon";
import { busyIdentificator } from "utils/busyWatcher";
import { preventDefault } from "@frui.ts/views";

export interface internalReportsFormProps {
  vmParent: InternalReportsViewModel;
  vm: InternalReportsCreateViewModel;
}

const InternalReportsForm = observer((props: internalReportsFormProps) => {
  const { vm, vmParent } = props;
  const isDownloadBusy = vm.busyWatcher.checkBusy(
    busyIdentificator([vm.item?.fromMonth, vm.item?.fromYear, vm.item?.toMonth, vm.item?.toYear])
  );

  return (
    <Modal show={true} onHide={vmParent.onClose} dialogClassName="modal-md" onEscapeKeyDown={vmParent.onClose} centered>
      <Modal.Body>
        <Form onSubmit={preventDefault(vm.onFormSubmit)}>
          <Form.Row>
            <FormGroup as={Col} md={6} lg={6} xl={6} target={vm.item} property="from">
              <FormLabel>{vm.translate("fromMonth")}</FormLabel>
              <AdvancedSelect
                target={vm.item}
                placeholder={vm.translateGeneral("choose")}
                allowEmpty={true}
                items={vm.monthlyOptions}
              />
            </FormGroup>
            <FormGroup as={Col} md={6} lg={6} xl={6} target={vm.item} property="to">
              <FormLabel>{vm.translate("toMonth")}</FormLabel>
              <AdvancedSelect
                target={vm.item}
                placeholder={vm.translateGeneral("choose")}
                allowEmpty={true}
                items={vm.monthlyOptionsTo}
              />
            </FormGroup>
            <FormGroup as={Col} md={6} lg={6} xl={6} target={vm.item} property="report">
              <FormLabel>{vm.translate("type")}</FormLabel>
              <AdvancedSelect target={vm.item} placeholder={vm.translateGeneral("choose")} items={vm.internalReportTypeOptions} />
            </FormGroup>
            <Form.Group as={Col} md={12} lg={12} xl={12} className="d-flex justify-content-center">
              <Button
                className="d-flex justify-content-center mt-md-5 rounded"
                type="submit"
                disabled={isDownloadBusy}
                iconLeft={isDownloadBusy ? IconType.Spinner : undefined}>
                {vm.translateGeneral("generateReport")}
              </Button>
            </Form.Group>
          </Form.Row>
        </Form>
      </Modal.Body>
    </Modal>
  );
});

export default InternalReportsForm;
